import { createClient } from '@supabase/supabase-js';

    // Supabase configuration
    // We use a valid URL format as a fallback to prevent the app from crashing
    // if the environment variables are not yet set.
    const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
    const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder-key';

    // Create Supabase client
    export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true,
        // Add these options for better session persistence
        flowType: 'pkce', // Use PKCE flow for better security
        debug: false, // Set to true for debugging auth issues
      }
    });

    // Helper to check if Supabase is properly configured
    export const isSupabaseConfigured = () => {
      return import.meta.env.VITE_SUPABASE_URL && 
             import.meta.env.VITE_SUPABASE_URL !== 'https://placeholder.supabase.co';
    };

    // Database table names
    export const TABLES = {
      USERS: 'users',
      TEAMS: 'teams',
      ACCOUNTS: 'accounts',
      CONTACTS: 'contacts',
      OPPORTUNITIES: 'opportunities',
      OPPORTUNITY_HISTORY: 'opportunity_history'
    };

    // User roles
    export const USER_ROLES = {
      ADMIN: 'Admin',
      SALES: 'Sales'
    };

    // Opportunity stages
    export const OPPORTUNITY_STAGES = {
      LEAD: 'Lead',
      QUALIFIED: 'Qualified',
      PROPOSAL: 'Proposal',
      NEGOTIATION: 'Negotiation',
      CLOSED_WON: 'Closed Won',
      CLOSED_LOST: 'Closed Lost'
    };

    // Currency options
    export const CURRENCIES = ['USD', 'EUR', 'GBP', 'CAD', 'AUD', 'JPY'];